module.exports = __webpack_public_path__ + "static/media/award-ribbon-icon-everdays-blue.8784f306.svg";